import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IBaCoverageHeadProps } from './IBaCoverageHeadProps';

/**
 * Шапка «Покриття аналізом» (прототип v4 bdSummary, bdModes): назва 18px, підсумок «N елементів аналізу · M з K модулів повністю охоплено ·
 * G прогалин» і перемикач рядків матриці «Усі модулі» / «З прогалинами» (radiogroup, вибраний — біла пігулка з тінню).
 */
export function BaCoverageHead({ coverage, gapsOnly, onMode }: IBaCoverageHeadProps) {
  const { t } = useTranslation();
  const summary = [
    t('modBody.ba.items', { count: coverage.total }),
    t('modBody.ba.full', { full: coverage.full, total: coverage.rows.length }),
    t('modBody.ba.gapsN', { count: coverage.gaps }),
  ].join(' · ');
  return (
    <div className="ba-head">
      <div className="ba-head__text">
        <strong className="ba-head__title">{t('modBody.ba.title')}</strong>
        <span className="ba-head__sum">{summary}</span>
      </div>
      <div className="ba-modes" role="radiogroup" aria-label={t('modBody.ba.rows')}>
        {[false, true].map((gaps) => (
          <button key={String(gaps)} type="button" role="radio" aria-checked={gapsOnly === gaps} className={cx('ba-modes__btn', gapsOnly === gaps && 'is-on')}
            onClick={() => onMode(gaps)}>
            {t(gaps ? 'modBody.ba.withGaps' : 'modBody.ba.allModules')}
          </button>
        ))}
      </div>
    </div>
  );
}
